import { render, staticRenderFns } from "./modalAddAttribute.vue?vue&type=template&id=7505e820&"
import script from "./modalAddAttribute.vue?vue&type=script&lang=js&"
export * from "./modalAddAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports